import React from "react";
import locations from '../data/ubicaciones';
import { Link } from 'react-router-dom';
const Locations = () => {
  return (
    <div className="page">
      <div className="page-header">
        <h1>Nuestras Ubicaciones</h1>
        <Link to="/" className="back-button">
          ← Volver al inicio
        </Link>
      </div>
      
      <div className="locations-list">
        {locations.map((loc, index) => (
          <div key={index} className="location-card">
            <h3>{loc.locationName}</h3>
            <p>{loc.address}</p>
            <a href={loc.mapUrl} target="_blank" rel="noopener noreferrer" className="map-link">
              📍 Ver en mapa
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Locations;